/**
 * @generated SignedSource<<57511de935ede13a42b589519f522748>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodPendingMessage_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentMethodPendingMessage_charge";
};
export type PaymentMethodPendingMessage_charge$key = {
  readonly " $data"?: PaymentMethodPendingMessage_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodPendingMessage_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodPendingMessage_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "f453ef0783bb0ea6e735e4a742a0eae4";

export default node;
